<template src="./RegisterMedicine.html"></template>
<script>
import mixins from "../../../../../Mixins.js";
export default {
  name: "registerMedicine",
  mixins: [mixins],
  data() {
    return {
      filooMedicine: [],
      emptyField: true,
      medicine: {
        id: null,
        active: null,
        product: "",
        activePrinciple: "",
        presentation: "",
        laboratory: "",
        usage: "",
      },
      titlePopupMedicines: "Listagem de medicamentos do sistema",
      showModalMedicine: false,
      isEdit: false,
      searchMedicine: "",
      windowWidth: 0,
      currentx: 1,
      numPages: 0,
      pagination: false,
      alertMessage: "",
      invalidFieldsMessage: "Campo Obrigatório",
      invalidFields: {
        product: false,
        activePrinciple: false,
        presentation: false,
        laboratory: false,
      },
      temporalTr : {}
    };
  },
  mounted: function () {
    const vm = this;
    vm.init();
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  watch: {
    "medicine.product": function (newVal) {
      const vm = this;
      vm.invalidFields.product =
        vm.testNullUndefinedEmpty(newVal) && vm.invalidFields.product;
    },
    "medicine.activePrinciple": function (newVal) {
      const vm = this;
      vm.invalidFields.activePrinciple =
        vm.testNullUndefinedEmpty(newVal) && vm.invalidFields.activePrinciple;
    },
    "medicine.presentation": function (newVal) {
      const vm = this;
      vm.invalidFields.presentation =
        vm.testNullUndefinedEmpty(newVal) && vm.invalidFields.presentation;
    },
    "medicine.laboratory": function (newVal) {
      const vm = this;
      vm.invalidFields.laboratory =
        vm.testNullUndefinedEmpty(newVal) && vm.invalidFields.laboratory;
    },
    currentx: function () {
      const vm = this;
      vm.changePagination();
    },
  },

  computed: {
    isValid: function () {
      return this.emptyField === true;
    },
  },

  methods: {
    init() {
      const vm = this;
      vm.getMedicines();
    },
    getMedicines() {
      const vm = this;
      const page = vm.currentx - 1;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "medicines?page=" +
            page +
            "&search=" +
            vm.searchMedicine +
            "&size=10&sort=product,asc&all=true",
          {
            headers: { Authorization: vm.$session.get("bearerDefault") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.filooMedicine = response.data.content;
            vm.numPages = response.data.totalPages;
            vm.pagination = vm.numPages > 1;
          }
        })
        .catch(function () {
          vm.$swal({
            title: "Atenção!",
            text:
              "Não foi possível listar os medicamentos, contacte o administrador do sistema.",
            icon: "error",
          });
        });
    },
    editMedicine(tr) {
      const vm = this;
      vm.showModalMedicine = true;
      vm.isEdit = true;
      vm.getMedicine(tr);
    },
    getMedicine(tr) {
      const vm = this;
      vm.medicine.id = tr.id;
      vm.medicine.active = tr.active;
      vm.medicine.product = tr.product;
      vm.medicine.activePrinciple = tr.activePrinciple;
      vm.medicine.presentation = tr.presentation;
      vm.medicine.laboratory = tr.laboratory;
      vm.medicine.usage = tr.usage;
    },
    updateMedicine() {
      const vm = this;
      let isInvalid = vm.validateFields();
      if (!isInvalid) {
        vm.axios
          .put(
            vm.$store.state.filooServer + "medicines/" + vm.medicine.id,
            vm.medicine,
            {
              headers: { Authorization: vm.$session.get("bearerDefault") },
            }
          )
          .then(function (response) {
            if (response.status === 200) {
              vm.showModalMedicine = false;
              vm.showNotifySuccess(
                "Operação realizada",
                "Os dados do medicamento  <b>" +
                  vm.medicine.product +
                  "</b> foram alterados com sucesso.",
                4000
              );
              vm.resetMedicine();
              vm.getMedicines();
            }
          })
          .catch(function () {
            vm.showPageMedicine = false;
            vm.showNotifyError("Não foi possível alterar o medicamento", 6000);
          });
      }
    },
    resetMedicine() {
      const vm = this;
      vm.medicine.id = null;
      vm.medicine.active = "";
      vm.medicine.product = "";
      vm.medicine.activePrinciple = "";
      vm.medicine.presentation = "";
      vm.medicine.laboratory = "";
      vm.medicine.usage = "";
    },
    changeActive(tr) {
      const vm = this;
      vm.getMedicine(tr);
      vm.medicine.active = !vm.medicine.active;
      vm.axios
        .put(
          vm.$store.state.filooServer + "medicines/" + vm.medicine.id,
          vm.medicine,
          {
            headers: { Authorization: vm.$session.get("bearerDefault") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.$bvModal.hide("modal-status-medicine");
            vm.$swal(
            "Sucesso!",
            "Status do medicamento alterado",
            "success"
          );
            vm.temporalTr = {};
            vm.resetMedicine();
            vm.getMedicines();
          }
        })
        .catch(function () {
          vm.$bvModal.hide("modal-status-medicine");
          vm.showNotifyError("Não foi possível alterar o status do medicamento", 6000);
        });
    },
    openAlert(tr) {
      const vm = this;
      vm.$bvModal.show("modal-status-medicine");
      vm.temporalTr = tr;
      vm.alertMessage = tr.active ?
      `Deseja ativar o medicamento: ${tr.product} ?`:
      `Deseja desativar o medicamento: ${tr.product} ?`;
    },
    acceptAlert() {
      const vm = this;
      vm.changeActive(vm.temporalTr);
    },

    addNewMedicine() {
      const vm = this;
      vm.resetMedicine();
      vm.showModalMedicine = true;
      vm.isEdit = false;
    },
    saveNewMedicine() {
      const vm = this;
      let isInvalid = vm.validateFields();
      if (!isInvalid) {
        vm.medicine.active = true;
        vm.axios
          .post(vm.$store.state.filooServer + "medicines", vm.medicine, {
            headers: { Authorization: vm.$session.get("bearerDefault") },
          })
          .then(function (response) {
            if (response.status === 200) {
              vm.showModalMedicine = false;
              vm.showNotifySuccess(
                "Operação realizada",
                "Os medicamento  <b>" +
                  vm.medicine.product +
                  "</b> foi criado com sucesso.",
                4000
              );
              vm.resetMedicine();
              vm.getMedicines();
            }
          })
          .catch(function () {
            vm.showNotifyError("Não foi possível criar um novo medicamento", 6000);
          });
      }
    },
    changeSearchMedicine() {
      const vm = this;
      vm.currentx = 1;
      vm.getMedicines();
    },

    changePagination() {
      const vm = this;
      vm.getMedicines();
    },

    validateFields() {
      const vm = this;
      let invalid = vm.invalidFields;
      invalid.product = vm.testNullUndefinedEmpty(vm.medicine.product);
      invalid.activePrinciple = vm.testNullUndefinedEmpty(
        vm.medicine.activePrinciple
      );
      invalid.presentation = vm.testNullUndefinedEmpty(
        vm.medicine.presentation
      );
      invalid.laboratory = vm.testNullUndefinedEmpty(vm.medicine.laboratory);
      return (
        invalid.product ||
        invalid.activePrinciple ||
        invalid.presentation ||
        invalid.laboratory
      );
    },

    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style lang="scss" src="./RegisterMedicine.scss">
</style>